module.exports = __webpack_public_path__ + "static/media/flag-ee.31dd21ef.webp";